module.exports = __webpack_public_path__ + "static/img/souhu.91ca9573.jpg";